import styled from 'styled-components'
import { FONT } from '../../../../utils'

export const H3 = styled.h3`
   ${FONT({ size: '16px', weight: '700' })}
   margin-top: 30px;
`
